import { useInfiniteQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { filesAPI } from '../services/api';

export function useFiles({ folderId, search = '', ordering = '-created_at' }) {
  // When search is active, omit folderId so the backend searches globally
  const effectiveFolderId = search ? undefined : folderId;

  return useInfiniteQuery({
    queryKey: ['files', { folderId, search, ordering }],
    queryFn: async ({ pageParam = 1, signal }) => {
      const res = await filesAPI.list({ folderId: effectiveFolderId, page: pageParam, search, ordering, signal });
      return res.data;
    },
    getNextPageParam: (lastPage) => {
      if (!lastPage.next) return undefined;
      const url = new URL(lastPage.next);
      return Number(url.searchParams.get('page'));
    },
    initialPageParam: 1,
    staleTime: 30_000,
  });
}

export function useDeleteFile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => filesAPI.delete(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['files'] });
      qc.invalidateQueries({ queryKey: ['folders'] });
    },
  });
}

export function useUpdateFile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => filesAPI.update(id, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['files'] });
    },
  });
}
